import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { OnlyNumbersDirective } from '../directives/only-numbers.directive';
import { NameValidatorDirective } from '../directives/name-validator.directive';
import { PasswordValidatorDirective } from '../directives/password-validator.directive';
import { TelNumberOnlyDirective } from '../directives/tel-number-only.directive';
import { DocumentNumberDirective } from '../directives/doc-number-only.directive';
import { TruncatePipe } from '../pipes/truncate.pipe';



@NgModule({
  declarations: [
    OnlyNumbersDirective,
    NameValidatorDirective,
    TelNumberOnlyDirective,
    PasswordValidatorDirective,
    DocumentNumberDirective,
    TruncatePipe,
  ],
  imports: [CommonModule],
  exports: [
    OnlyNumbersDirective,
    NameValidatorDirective,
    TelNumberOnlyDirective,
    PasswordValidatorDirective,
    DocumentNumberDirective,
    TruncatePipe
  ]
})
export class SharedModule { }
